import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import LazyLoad from 'react-lazyload'
import GatsbyImage from 'gatsby-image'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import { RootMeta } from 'components/Meta'
import Intro from 'components/Storiespage/Intro'
import StoryOne from 'components/Storiespage/StoryOne'
import StoryOneTitle from 'components/Storiespage/StoryOneTitle'
import StoryOneExcerpt from 'components/Storiespage/StoryOneExcerpt'
import StoryOneLearnMoreBtn from 'components/Storiespage/StoryOneLearnMoreBtn'
import StoryTwo from 'components/Storiespage/StoryTwo'
import StoryTwoTitle from 'components/Storiespage/StoryTwoTitle'
import StoryTwoExcerpt from 'components/Storiespage/StoryTwoExcerpt'
import StoryTwoLearnMoreBtn from 'components/Storiespage/StoryTwoLearnMoreBtn'
import OtherStories from 'components/Storiespage/OtherStories'
import OtherStoryTitle from 'components/Storiespage/OtherStoryTitle'
import OtherStoryExcerpt from 'components/Storiespage/OtherStoryExcerpt'
import OtherStoryLearnMoreBtn from 'components/Storiespage/OtherStoryLearnMoreBtn'
import StoriesPagination from 'components/Storiespage/StoriesPagination'
import removeFileExt from 'utils/removeFileExt'

const styles = (theme) => ({
  root: {
    padding: '15px 0',
  },
  introContainer: {
    position: 'relative',
    height: '100vh',
  },
  storyOneContainer: {
    minHeight: 600,
    [theme.breakpoints.down('sm')]: {
      paddingTop: 40,
    },
    [theme.breakpoints.down('xs')]: {
      padding: 20,
      height: 'auto',
    },
    '& img': {
      transition: 'transform 1.2s !important',
    },
    '&:hover': {
      '& img': {
        transform: 'scale(1.15) rotate(-10deg) !important',
      },
    },
  },
  storyOnePhotoWrapper: {
    width: '25%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: 'auto',
      justifyContent: 'center',
    },
  },
  storyOnePhoto: {
    borderRadius: '50%',
    objectFit: 'cover',
    margin: 'auto',
    width: 320,
    height: 320,
    [theme.breakpoints.down('md')]: {
      width: 260,
      height: 260,
    },
    [theme.breakpoints.down('sm')]: {
      width: 320,
      height: 320,
    },
    [theme.breakpoints.down('xs')]: {
      width: 220,
      height: 220,
    },
  },
  storyOneDetailsWrapper: {
    width: '60%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.down('xs')]: {
      height: 'auto',
      display: 'block',
    },
  },
  storyOneDetails: {
    padding: 30,
    maxWidth: 1000,
    [theme.breakpoints.down('xs')]: {
      padding: 10,
    },
  },
  storyOneTitle: {
    textTransform: 'none',
    fontSize: '1.7em',
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.4em',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.2em',
    },
  },
  storyOneExcerpt: {
    padding: '20px 0',
    fontSize: '1em',
    lineHeight: 1.9,
    fontWeight: 300,
    color: theme.palette.text.soft,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9em',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.7em',
    },
  },
  storyTwoContainer: {
    minHeight: 600,
    flexDirection: 'row-reverse',
    [theme.breakpoints.down('sm')]: {
      paddingTop: 40,
    },
    [theme.breakpoints.down('xs')]: {
      padding: 20,
      height: 'auto',
    },
    '& img': {
      transition: 'transform 1.2s !important',
    },
    '&:hover': {
      '& img': {
        transform: 'scale(1.15) rotate(-10deg) !important',
      },
    },
  },
  storyTwoDetailsWrapper: {
    width: '65%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.down('xs')]: {
      height: 'auto',
      display: 'block',
    },
  },
  storyTwoDetails: {
    padding: '30px 0 30px 70px',
    maxWidth: 900,
    [theme.breakpoints.down('sm')]: {
      padding: 30,
    },
    [theme.breakpoints.down('xs')]: {
      padding: 10,
    },
  },
  storyTwoTitle: {
    textTransform: 'none',
    color: '#fff',
    fontSize: '1.7em',
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.4em',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.2em',
    },
  },
  storyTwoExcerpt: {
    padding: '30px 0',
    fontSize: '1em',
    lineHeight: 1.9,
    fontWeight: 300,
    color: '#cdd9e3',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9em',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.7em',
    },
  },
  storyTwoPhotoWrapper: {
    width: '35%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: 'auto',
      justifyContent: 'center',
    },
  },
  storyTwoPhoto: {
    borderRadius: '50%',
    objectFit: 'cover',
    margin: 'auto',
    width: 320,
    height: 320,
    [theme.breakpoints.down('md')]: {
      width: 260,
      height: 260,
    },
    [theme.breakpoints.down('sm')]: {
      width: 320,
      height: 320,
    },
    [theme.breakpoints.down('xs')]: {
      width: 220,
      height: 220,
    },
  },
  learnMoreBtn: {
    transition: 'background 0.7s, color 0.7s',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8em',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.7em',
      width: '100%',
    },
    '&:hover': {
      background: theme.palette.primary.dark,
      color: '#fff',
    },
  },
  learnMoreBtnInverse: {
    background: theme.palette.secondary.main,
    color: '#fff',
    transition: 'background 0.7s, color 0.7s',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8em',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.7em',
      width: '100%',
    },
    '&:hover': {
      background: theme.palette.secondary.dark,
    },
  },
  otherStoriesContainer: {
    padding: '70px 50px 0',
    [theme.breakpoints.down('sm')]: {
      padding: '40px 0 0',
    },
  },
  inspirationalQuote: {
    fontStyle: 'italic',
    color: theme.palette.text.light,
    fontWeight: 300,
  },
  otherStoriesPhoto: {
    borderRadius: '50%',
    objectFit: 'cover',
    width: 320,
    height: 320,
    margin: 'auto',
    display: 'block',
    [theme.breakpoints.down('md')]: {
      width: 260,
      height: 260,
    },
    [theme.breakpoints.down('sm')]: {
      width: 320,
      height: 320,
    },
    [theme.breakpoints.down('xs')]: {
      width: 220,
      height: 220,
    },
    '& img': {
      transition: 'transform 1.2s !important',
    },
    '&:hover': {
      '& img': {
        transform: 'scale(1.15) rotate(-10deg) !important',
      },
    },
  },
  otherStoryDetails: {
    padding: '30px 70px 70px 70px',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      padding: 30,
    },
    [theme.breakpoints.down('xs')]: {
      textAlign: 'left',
    },
  },
  otherStoryTitle: {
    textTransform: 'none',
    fontSize: '1.3em',
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1em',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.2em',
    },
  },
  otherStoryExcerpt: {
    padding: '20px 0',
    fontSize: '0.9em',
    lineHeight: 1.9,
    fontWeight: 300,
    color: theme.palette.text.soft,
    maxHeight: 187,
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9em',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.7em',
    },
  },
  otherStoryLearnMoreBtn: {
    transition: 'background 0.7s, color 0.7s',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.6em',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.6em',
      width: '100%',
    },
    '&:hover': {
      background: theme.palette.primary.dark,
      color: '#fff',
    },
  },
})

const StoriesPage = ({ classes, theme, data, pathContext }) => {
  const {
    site: { siteMetadata },
    imageSharp: banner,
    allImageSharp: { edges: thumbnails },
  } = data
  const { group, index, pageCount } = pathContext

  const thumbnailSizes = thumbnails.reduce((acc, { node }) => {
    const { originalName, ...rest } = node.sizes
    const originalNameWithoutExt = removeFileExt(originalName)

    if (!acc[originalNameWithoutExt]) {
      acc[originalNameWithoutExt] = rest
    }
    return acc
  }, {})

  const orderedStories = group.sort((a, b) => {
    const dateA = moment(a.frontmatter.date)
    const dateB = moment(b.frontmatter.date)
    if (dateA.isAfter(dateB)) return -1
    if (dateA.isBefore(dateB)) return 1
    return 0
  })

  const storyOne = orderedStories[0]
  const storyTwo = orderedStories[1]
  const otherStories = orderedStories.slice(2)

  return (
    <div>
      <RootMeta
        url={siteMetadata.siteUrl + '/weight-loss-stories'}
        title={
          siteMetadata.siteTitle +
          ' | ' +
          'Real Life Weight Loss Success Stories From Real People'
        }
        description="Real life success stories shared by people who've been successful achieving their weight loss goal(s). These are inspirational stories from people who have done the almost-impossible by taking action and making it all happen by willpower, positive thinking, mindset and determination."
        breadCrumb={[
          {
            url: siteMetadata.siteUrl + '/weight-loss-stories',
            name: 'Weight-Loss-Stories',
          },
        ]}
      />
      <Intro
        wrapperClassName={classes.introContainer}
        gatsbyImage={
          <GatsbyImage
            style={{ height: '100vh' }}
            imgStyle={{ height: '100vh' }}
            sizes={banner.sizes}
            alt="Real life success stories shared by people who lost weight"
            title="Real life success stories shared by people who lost weight"
          />
        }
        inspirationalQuote={'"Will Is A Skill" - Charushila Biswas'}
      />
      {!storyOne &&
        !storyTwo &&
        !otherStories && (
          <Typography variant="display1" align="center" style={{ padding: 20 }}>
            No stories available.
          </Typography>
        )}
      {storyOne && (
        <LazyLoad height={200}>
          <StoryOne
            className={classes.storyOneContainer}
            leftClassName={classes.storyOnePhotoWrapper}
            rightClassName={classes.storyOneDetailsWrapper}
            left={
              <GatsbyImage
                className={classes.storyOnePhoto}
                sizes={thumbnailSizes['st_' + storyOne.frontmatter.date]}
                alt={storyOne.frontmatter.title}
                title={storyOne.frontmatter.title}
              />
            }
            right={
              <div className={classes.storyOneDetails}>
                <StoryOneTitle
                  className={classes.storyOneTitle}
                  text={storyOne.frontmatter.title}
                />
                <StoryOneExcerpt
                  className={classes.storyOneExcerpt}
                  text={storyOne.excerpt}
                />
                <StoryOneLearnMoreBtn
                  url={storyOne.fields.slug}
                  btnClassName={classes.learnMoreBtn}
                  text="Learn More"
                />
              </div>
            }
          />
        </LazyLoad>
      )}
      {storyTwo && (
        <StoryTwo
          className={classes.storyTwoContainer}
          leftClassName={classes.storyTwoDetailsWrapper}
          rightClassName={classes.storyTwoPhotoWrapper}
          style={{ background: theme.palette.primary.main }}
          left={
            <div className={classes.storyTwoDetails}>
              <StoryTwoTitle
                className={classes.storyTwoTitle}
                text={storyTwo.frontmatter.title}
              />
              <StoryTwoExcerpt
                className={classes.storyTwoExcerpt}
                text={storyTwo.excerpt}
              />
              <StoryTwoLearnMoreBtn
                url={storyTwo.fields.slug}
                btnClassName={classes.learnMoreBtnInverse}
                text="Learn More"
              />
            </div>
          }
          right={
            <GatsbyImage
              className={classes.storyTwoPhoto}
              sizes={thumbnailSizes['st_' + storyTwo.frontmatter.date]}
              alt={storyTwo.frontmatter.title}
              title={storyTwo.frontmatter.title}
            />
          }
        />
      )}
      {otherStories &&
        otherStories.length && (
          <OtherStories
            className={classes.otherStoriesContainer}
            header={
              <Typography variant="display1" align="center">
                Other Stories
              </Typography>
            }
            inspirationalQuote={
              <Typography
                variant="title"
                align="center"
                classes={{ root: classes.inspirationalQuote }}
              >
                If you are tired of starting over, stop giving up
              </Typography>
            }
            render={(Story) =>
              otherStories.map((node, i) => (
                <Story
                  key={node.frontmatter.pageType + i}
                  top={
                    <GatsbyImage
                      className={classes.otherStoriesPhoto}
                      sizes={thumbnailSizes['st_' + node.frontmatter.date]}
                      alt={node.frontmatter.title}
                      title={node.frontmatter.title}
                    />
                  }
                  bottom={
                    <div className={classes.otherStoryDetails}>
                      <OtherStoryTitle
                        className={classes.otherStoryTitle}
                        text={node.frontmatter.title}
                      />
                      <OtherStoryExcerpt
                        className={classes.otherStoryExcerpt}
                        text={node.excerpt}
                      />
                      <OtherStoryLearnMoreBtn
                        btnClassName={classes.otherStoryLearnMoreBtn}
                        url={node.fields.slug}
                        text="Learn More"
                      />
                    </div>
                  }
                />
              ))
            }
          />
        )}
      <StoriesPagination
        currentPage={index}
        totalItems={group.length * pageCount}
        itemsPerPage={group.length}
        prefix="/weight-loss-stories"
      />
      <div style={{ padding: 20 }} />
    </div>
  )
}

StoriesPage.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  pathContext: PropTypes.shape({
    group: PropTypes.arrayOf(
      PropTypes.shape({
        excerpt: PropTypes.string,
        fields: PropTypes.object,
        fileAbsolutePath: PropTypes.string,
        frontmatter: PropTypes.shape({
          date: PropTypes.string,
          pageType: PropTypes.string,
          shortDescription: PropTypes.string,
          source: PropTypes.string,
          thumbnail: PropTypes.string, // not using atm
          tags: PropTypes.arrayOf(PropTypes.string),
          title: PropTypes.string,
        }),
        html: PropTypes.string,
        id: PropTypes.string,
        timeToRead: PropTypes.number,
      }),
    ),
    index: PropTypes.number,
    pageCount: PropTypes.number,
    pathPrefix: PropTypes.string,
    additionalContext: PropTypes.object,
  }),
}

// prettier-ignore
// eslint-disable-next-line
export const query = graphql`
  query WeightLossStories {
    site {
      siteMetadata {
        siteTitle
        siteUrl
        siteDescription
      }
    }
    allImageSharp(filter: { id: { regex: "/\/images\/stories/" } }) {
      edges {
        node {
          sizes(maxWidth: 450, traceSVG: { color: "#e5ebed" }) {
            ...GatsbyImageSharpSizes_tracedSVG
            originalName
          }
        }
      }
    }
    imageSharp(id: { regex: "/stories-banner/" } ) {
      sizes (maxWidth: 3225, traceSVG: { color: "#285978" }) {
        ...GatsbyImageSharpSizes_tracedSVG
        originalName
      }
    }
  }
`

export default withStyles(styles, { withTheme: true })(StoriesPage)



// WEBPACK FOOTER //
// ./src/templates/stories.js